import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { getAllTicket } from '../../api/ticketApi';
import {
  NAVIGATION_LINKS,
  ADMIN_NAVIGATION_LINKS,
  ADMIN_USER_NAVIGATION_LINKS,
  BOTTOM_LINKS,
} from '../../lib/const/navbar-links';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import axios from 'axios';
import { Constants } from '../../lib/const/constants';
import SidebarIcon from './SidebarIcons';


const linkClass =
  'flex items-center gap-3 py-2.5 px-4 hover:no-underline text-sm font-medium mb-0.5 rounded-lg w-full transition-colors duration-150';
const activeClass = `
  h-[50px]
  pl-5
  rounded-2xl
  gap-3
  flex items-center
  
  text-white
  bg-gradient-to-r from-[#2C3E50] to-[#34495E]
  shadow-[0px_4px_6px_-4px_rgba(44,62,80,0.2),0px_10px_15px_-3px_rgba(44,62,80,0.2)]
`;
const activeRevertClass = 'bg-[#0a38ad] rounded-lg text-white w-full';
const inactiveClass = 'text-[#111827] ';
  

const getlogo = () => {
  const path = window.location.pathname;
  if (path.includes('DebitTransactions') || path.includes('CreditTransactions') || path.includes('memberships') || path.includes('createmembership') || path.includes('createbulkmemebership')) {
    return "/fx_logo.png";
  }
  else {
    return "/fx_logo_old.png"
  }
}

const getUserTypeFromSession = () => {
  const raw = sessionStorage.getItem('login_workspaces');
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed?.type || parsed?.[0]?.type || null;
  } catch (err) {
    console.error('login_workspaces parse error:', err);
    return null;
  }
};

const filterLinksByType = (allLinks, userType) => {
  const validLinks = allLinks.filter(Boolean);
  if (userType === 'business') {
    return validLinks.filter((l) => l.key !== 'Sendmoney');
  }
  if (userType === 'individual') {
    const filtered = validLinks.filter(
      (l) =>
        l.key !== 'pay' &&
        l.key !== 'convert' &&
        l.key !== 'bulkupload' &&
        l.key !== 'dashboard' &&
        l.key !== 'bulkupload1' &&
        l.key !== 'FasterPayment'
    );
    const sendMoneyIndex = filtered.findIndex((l) => l.key === 'Sendmoney');
    if (sendMoneyIndex > -1) {
      const [sendMoneyItem] = filtered.splice(sendMoneyIndex, 1);
      filtered.unshift(sendMoneyItem);
    }
    return filtered;
  }
  return validLinks;
};

const Sidebar = ({ isSidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [showconvertTab, setshowconvertTab] = useState(false);
  const [navlink, setnavlink] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const timeoutRef = useRef(null);
  const [filteredTickets, setFilteredTickets] = useState([]);

  const accountType = sessionStorage.getItem('account_type');
  const capitalize = (accountType) =>
  accountType ? accountType.charAt(0).toUpperCase() + accountType.slice(1) : '';

  const logout = async () => {
    sessionStorage.clear();
    navigate('/business');
  };

  const setAsyncData = async (key, value) => {
    sessionStorage.setItem(key, value);
  };

  const removeData = async (key) => {
    sessionStorage.removeItem(key);
  };

  const revertToSelf = async () => {
    const keysToRemove = [
      'login_id',
      'login_full_name',
      'login_email',
      'login_phone',
      'login_date_of_birth',
      'login_country_code',
      'login_country_id',
      'login_country_name',
      'login_nationality',
      'login_registration_step',
      'login_is_banking_user',
      'login_status',
      'login_yoti_status',
      'login_workspaces',
      'login_workspaces_id',
      'login_token',
      'login_address',
      'login_postcode',
      'login_city',
      'login_currency_code_iso',
      'defaultBank',
      'clearBankCustomerId',
      'clearBankCustomerBankCode',
      'clearBankCustomerIBAN',
      'clearBankCustomerWalletId',
      'clearBankCustomerSWIFTCode',
      'clearBankCustomerAccountName',
      'clearBankCustomerWalletNumber',
      'clearBankCustomerSortCode',
      'clearBankCustomerServiceProviderAccountId',
      'clearBankCustomerContactId',
      'kyc_submitted',
    ];
    keysToRemove.forEach(removeData);

    setAsyncData('staff_login_id', sessionStorage.getItem('staff_login_id'));
    setAsyncData('login_id', sessionStorage.getItem('staff_login_id'));
    setAsyncData('login_full_name', sessionStorage.getItem('staff_login_full_name'));
    setAsyncData('login_email', sessionStorage.getItem('staff_login_email'));
    setAsyncData('login_phone', sessionStorage.getItem('staff_login_phone'));
    setAsyncData('login_date_of_birth', sessionStorage.getItem('staff_login_date_of_birth'));
    setAsyncData('login_country_code', sessionStorage.getItem('staff_login_country_code'));
    setAsyncData('login_country_id', sessionStorage.getItem('staff_login_country_id'));
    setAsyncData('login_country_name', sessionStorage.getItem('staff_login_country_name'));
    setAsyncData('login_nationality', sessionStorage.getItem('staff_login_nationality'));
    setAsyncData('staff_login_token', sessionStorage.getItem('staff_login_token'));
    setAsyncData('admin_login', '1');
    setAsyncData('kyc_submitted', sessionStorage.getItem('staff_kyc_submitted'));

    navigate('/memberships');
    location.reload();
  };

  const loadData = async () => {
    const re_kyc = sessionStorage.getItem('re_kyc');
    if (JSON.parse(re_kyc) === 1) navigate('/sumsubReKyc');

    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');

    setAsyncData('balances', '');
    setAsyncData('conversions', '');

    try {
      const resp = await axios.get(
        `${Constants.BASE_URL}API-FX-165-CCTRANSACTIONS/${login_workspaces_id}?page=1&from=1970-01-01&to=1970-02-01`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(login_token)}`,
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      );

      if (resp.data.menu.length > 0) {
        resp.data.menu.forEach((menu) => {
          if (menu.tab_id === 2)
            setAsyncData('balances', JSON.stringify(menu.tab_id));
          if (menu.tab_id === 1)
            setAsyncData('conversions', JSON.stringify(menu.tab_id));
        });
      }
    } catch (err) {
      console.error(err);
    }

    const admin_login = sessionStorage.getItem('admin_login');
    const conversions = sessionStorage.getItem('conversions');
    if (conversions) setshowconvertTab(true);

    const userType = getUserTypeFromSession();

    if (admin_login === '1') {
      const staff_login_token = sessionStorage.getItem('staff_login_token');
      const login_token = sessionStorage.getItem('login_token');
      if (staff_login_token && login_token) {
        const filtered = filterLinksByType(ADMIN_USER_NAVIGATION_LINKS, userType);
        setnavlink(filtered);
      } else {
        setnavlink(ADMIN_NAVIGATION_LINKS);
      }
    } else {
      const filtered = filterLinksByType(NAVIGATION_LINKS, userType);
      setnavlink(filtered);
    }

    setLoading(false);
  };

  const INACTIVITY_TIME = 10 * 60 * 1000;

  console.log(isActive);
  const resetTimer = () => {
    clearTimeout(timeoutRef.current);
    setIsActive(true);
    timeoutRef.current = setTimeout(() => {
      setIsActive(false);
      logout();
    }, INACTIVITY_TIME);
  };

  useEffect(() => {
    loadData();
    const user_events = ['mousemove', 'keydown', 'scroll', 'click'];
    user_events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer();

    const onNavRefresh = () => {
      const userType = getUserTypeFromSession();
      const admin_login = sessionStorage.getItem('admin_login');
      if (admin_login === '1') {
        const staff_login_token = sessionStorage.getItem('staff_login_token');
        const login_token_local = sessionStorage.getItem('login_token');
        if (staff_login_token && login_token_local) {
          setnavlink(ADMIN_USER_NAVIGATION_LINKS);
        } else {
          setnavlink(ADMIN_NAVIGATION_LINKS);
        }
      } else {
        setnavlink(filterLinksByType(NAVIGATION_LINKS, userType));
      }
    };
    window.addEventListener('nav-refresh', onNavRefresh);

    const onStorage = (e) => {
      if (!e || e.key === 'login_workspaces' || e.key === 'admin_login') {
        onNavRefresh();
      }
    };
    window.addEventListener('storage', onStorage);

    return () => {
      clearTimeout(timeoutRef.current);
      user_events.forEach((event) =>
        window.removeEventListener(event, resetTimer),
      );
      window.removeEventListener('nav-refresh', onNavRefresh);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  useEffect(() => {
    const workspace_id = sessionStorage.getItem('login_workspaces_id');
    const fetchTickets = async () => {
      try {
        const data = await getAllTicket(workspace_id);
        setFilteredTickets(data.results);
      } catch (err) {
        console.log('error', err);
      } finally {
        setLoading(false);
      }
    };
    fetchTickets();
  }, []);


  // const fullName = sessionStorage.getItem('login_workspace_name');
  const clearBankCustomerAccountName = sessionStorage.getItem('clearBankCustomerAccountName')
  const login_full_name = sessionStorage.getItem('login_full_name') 
  const account_type = sessionStorage.getItem('account_type')
  // const fullName = account_type === 'individual'? login_full_name:clearBankCustomerAccountName
  const fullName =
  account_type === 'individual'
    ? login_full_name?.replace(/^(Mr|Mrs)\s+/i, '')
    : clearBankCustomerAccountName;
  const initials = fullName
    ?.split(' ')
    .map((n) => n[0])
    .filter(Boolean)
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <div
      className={classNames(
        'fixed top-0 left-0 z-40',
        'w-64 h-screen flex flex-col',
        'bg-white',
        'border-r border-[#f0f0f0]',
        'shadow-[4px_0px_12px_-5px_rgba(32,51,88,0.16)]',
        'transition-transform transform',
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full',
        'sm:relative sm:translate-x-0'
      )}
    >

      <div
        style={{
          padding: '32px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexShrink: 0,
          minHeight: 80,
          width: '287px',
          height: '84px',
        }}
      >
        <img
          src={getlogo()}
          alt="FXMaster"
          style={{ width: '172px', height: '22px', display: 'block' }}
        />

        <button
          className="sm:hidden"
          onClick={() => setSidebarOpen(false)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 20,
            color: '#374151',
            lineHeight: 1,
            padding: '2px 4px',
          }}
          aria-label="Close sidebar"
        >
          ✕
        </button>
      </div>

      <div className="flex-1 overflow-y-auto" style={{ padding: '12px' }}>
        {!loading &&
          navlink.map((item) => {
            const isActive = pathname === item.path;

            if (item.key === 'reverttoself') {
              return (
                <button
                  key={item.key}
                  onClick={revertToSelf}
                  className={classNames(activeRevertClass, linkClass)}
                >
                  <SidebarIcon isActive={true} icon={item.icon} />
                  {item.label}
                </button>
              );
            }

            if (item.key === 'convert' && !showconvertTab) {
              return null;
            }

            return (
              <button
                key={item.key}
                onClick={() =>
                  item.key === 'logout'
                    ? logout()
                    : item.key === 'dashboard'
                      ? navigate(item.path, { state: { qr_login_completed: 1 } })
                      : navigate(item.path)
                }
                className={classNames(isActive ? activeClass : inactiveClass, linkClass)}
              >
                <SidebarIcon isActive={isActive} icon={item.icon} />
                <span className="flex items-center gap-2" style={item.key === 'logout' ? { color: '#dc2626', fontWeight: 600 } : {}}>
                  {item.label}
                  {item.key === 'contactsupport' &&
                    filteredTickets.length > 0 && (
                      <span
                        style={{
                          background: '#EB640A',
                          color: '#fff',
                          fontSize: 10,
                          fontWeight: 700,
                          padding: '1px 7px',
                          borderRadius: 999,
                          lineHeight: '18px',
                        }}
                      >
                        {filteredTickets.filter((t) => t.status_display === 'Open').length}
                      </span>
                    )}
                </span>
              </button>
            );
          })}
      </div>

      <div style={{ borderTop: '1px solid #f0f0f0', padding: '12px', flexShrink: 0 }}>
        {BOTTOM_LINKS.map((item) => (
          <button
            key={item.key}
            onClick={() =>
              item.key === 'logout' ? logout() : navigate(item.path)
            }
            className={classNames(linkClass, inactiveClass)}
          >
            <SidebarIcon isActive={false} icon={item.icon} />
            <span style={item.key === 'logout' ? { color: '#ef4444' } : {}}>
              {item.label}
            </span>
          </button>
        ))}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '10px 12px',
            marginTop: 4,
            borderRadius: 10,
          }}
        >
          {/* Avatar with initials + online dot */}
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: '32px',
              background: '#E5E7EB',
              color: '#1D2338',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '14px',
              fontWeight: 500,
              flexShrink: 0,
              position: 'relative',
            }}
          >
            {initials || 'U'}
            <span
              style={{
                position: 'absolute',
                bottom: 1,
                right: 1,
                width: 9,
                height: 9,
                background: '#22c55e',
                border: '1.5px solid #fff',
                borderRadius: '50%',
              }}
            />
          </div>
          <div style={{ overflow: 'hidden', flex: 1 }}>
            <div
              style={{
                fontSize: '13px',
                fontWeight: 500,
                color: '#1D2338',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {fullName || 'User'}
            </div>
            <div
              style={{
                fontSize: '12px',
                fontWeight: 400,
                color: '#676F7D',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {capitalize(accountType) || '—'} Account
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Sidebar.propTypes = {
  isSidebarOpen: PropTypes.bool.isRequired,
  setSidebarOpen: PropTypes.func.isRequired,
};

export default Sidebar;